<template>
  <Layout>
    <div class="thank-you-builder">
      <!-- Header -->
      <div class="builder-header">
        <div class="header-left">
          <button class="btn-back" @click="goBack">
            <i class="bx bx-arrow-back"></i>
          </button>
          <div class="form-title-section">
            <input
              v-model="pageData.name"
              type="text"
              class="form-title-input"
              placeholder="Nome da Página"
            />
            <span class="form-status" :class="pageData.is_default ? 'default' : ''">
              {{ pageData.is_default ? 'Padrão' : 'Personalizada' }}
            </span>
          </div>
        </div>
        <div class="header-right">
          <button class="btn-save" @click="save" :disabled="saving">
            <i class="bx" :class="saving ? 'bx-loader-alt bx-spin' : 'bx-save'"></i>
            {{ saving ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>

      <!-- Main Content -->
      <div class="builder-content">
        <!-- Left Panel: Configurações -->
        <div class="panel panel-left">
          <div class="config-scroll">
            <!-- Basic Information -->
            <div class="config-section">
              <h5>Informações Básicas</h5>
              <p class="text-muted small">Configure as informações gerais da página</p>

              <div class="form-check mt-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="is-default"
                  v-model="pageData.is_default"
                >
                <label class="form-check-label" for="is-default">
                  <i class="mdi mdi-star text-warning mr-1"></i>
                  Definir como página padrão do sistema
                </label>
                <small class="form-text text-muted">
                  Esta página será usada quando o formulário não especificar uma página customizada
                </small>
              </div>
            </div>

            <!-- Success Icon Settings -->
            <div class="config-section">
              <h5>Ícone de Sucesso</h5>
              <p class="text-muted small">Customize a aparência do ícone</p>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Fundo do Círculo</label>
                    <div class="color-input-group">
                      <input
                        v-model="pageData.icon_background_color"
                        type="color"
                        class="form-control form-control-color"
                      >
                      <input
                        v-model="pageData.icon_background_color"
                        type="text"
                        class="form-control form-control-sm ml-2"
                        style="max-width: 90px"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Cor do Ícone</label>
                    <div class="color-input-group">
                      <input
                        v-model="pageData.icon_color"
                        type="color"
                        class="form-control form-control-color"
                      >
                      <input
                        v-model="pageData.icon_color"
                        type="text"
                        class="form-control form-control-sm ml-2"
                        style="max-width: 90px"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Message Settings -->
            <div class="config-section">
              <h5>Mensagem Principal</h5>
              <p class="text-muted small">Personalize a mensagem de sucesso</p>

              <div class="form-group">
                <label>Texto da Mensagem</label>
                <input
                  v-model="pageData.message_text"
                  type="text"
                  class="form-control"
                  placeholder="{Nome}, seu cadastro foi realizado com sucesso!"
                >
                <small class="form-text text-muted">
                  Variáveis: <span class="badge badge-secondary mr-1">{Nome}</span>
                  <span class="badge badge-secondary mr-1">{Email}</span>
                  <span class="badge badge-secondary mr-1">{CodigoConfirmacao}</span>
                </small>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Cor do Texto</label>
                    <div class="color-input-group">
                      <input
                        v-model="pageData.message_color"
                        type="color"
                        class="form-control form-control-color"
                      >
                      <input
                        v-model="pageData.message_color"
                        type="text"
                        class="form-control form-control-sm ml-2"
                        style="max-width: 90px"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Tamanho da Fonte</label>
                    <select v-model="pageData.message_size" class="form-control">
                      <option value="14px">14px</option>
                      <option value="16px">16px</option>
                      <option value="18px">18px</option>
                      <option value="20px">20px</option>
                      <option value="24px">24px</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Content -->
            <div class="config-section">
              <h5>Conteúdo Adicional</h5>
              <p class="text-muted small">Adicione elementos extras</p>

              <!-- Show Confirmation Code -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <label class="mb-0">Exibir Código de Confirmação</label>
                  <p class="text-muted small mb-0">Mostrar código único de referência</p>
                </div>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="show-code"
                    v-model="pageData.show_confirmation_code"
                  >
                  <label class="custom-control-label" for="show-code"></label>
                </div>
              </div>

              <!-- Important Box -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <label class="mb-0">Box Importante</label>
                  <p class="text-muted small mb-0">Destacar informação importante</p>
                </div>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enable-important-box"
                    v-model="pageData.important_box_enabled"
                  >
                  <label class="custom-control-label" for="enable-important-box"></label>
                </div>
              </div>

              <div v-if="pageData.important_box_enabled" class="box-settings">
                <div class="form-group">
                  <label>Título do Box</label>
                  <input
                    v-model="pageData.important_box_title"
                    type="text"
                    class="form-control"
                    placeholder="IMPORTANTE"
                  >
                </div>

                <div class="form-group">
                  <label>Conteúdo do Box</label>
                  <textarea
                    v-model="pageData.important_box_content"
                    class="form-control"
                    rows="5"
                    placeholder="Enviamos um e-mail de confirmação para {Email}. Por favor, verifique sua caixa de entrada."
                  ></textarea>
                  <small class="form-text text-muted">
                    Use quebras de linha para parágrafos. Variáveis: {Nome}, {Email}, {CodigoConfirmacao}
                  </small>
                </div>

                <!-- Call-to-Action Button (dentro do box importante) -->
                <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
                  <div>
                    <label class="mb-0">Adicionar Botão</label>
                    <p class="text-muted small mb-0">Botão de ação dentro do box</p>
                  </div>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="enable-button"
                      v-model="pageData.button_enabled"
                    >
                    <label class="custom-control-label" for="enable-button"></label>
                  </div>
                </div>

                <div v-if="pageData.button_enabled">
                  <div class="form-group">
                    <label>Texto do Botão</label>
                    <input
                      v-model="pageData.button_text"
                      type="text"
                      class="form-control"
                      placeholder="Continuar"
                    >
                  </div>

                  <div class="form-group">
                    <label>URL de Redirecionamento</label>
                    <input
                      v-model="pageData.button_url"
                      type="text"
                      class="form-control"
                      placeholder="https://exemplo.com/dashboard"
                    >
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Cor do Botão</label>
                        <div class="color-input-group">
                          <input
                            v-model="pageData.button_color"
                            type="color"
                            class="form-control form-control-color"
                          >
                          <input
                            v-model="pageData.button_color"
                            type="text"
                            class="form-control form-control-sm ml-2"
                            style="max-width: 90px"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Cor do Texto</label>
                        <div class="color-input-group">
                          <input
                            v-model="pageData.button_text_color"
                            type="color"
                            class="form-control form-control-color"
                          >
                          <input
                            v-model="pageData.button_text_color"
                            type="text"
                            class="form-control form-control-sm ml-2"
                            style="max-width: 90px"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Redirecionamento Automático -->
            <div class="config-section">
              <h5>Redirecionamento Automático</h5>
              <p class="text-muted small">Redirecionar usuário após visualizar a página</p>

              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <label class="mb-0">Ativar Redirecionamento</label>
                  <p class="text-muted small mb-0">Redirecionar automaticamente após um tempo</p>
                </div>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enable-redirect"
                    v-model="pageData.redirect_enabled"
                  >
                  <label class="custom-control-label" for="enable-redirect"></label>
                </div>
              </div>

              <div v-if="pageData.redirect_enabled">
                <div class="form-group">
                  <label>URL de Redirecionamento</label>
                  <input
                    v-model="pageData.redirect_url"
                    type="url"
                    class="form-control"
                    placeholder="https://exemplo.com"
                  >
                  <small class="form-text text-muted">
                    URL completa para onde o usuário será redirecionado
                  </small>
                </div>

                <div class="form-group">
                  <label>Tempo para Redirecionar (segundos)</label>
                  <input
                    v-model.number="pageData.redirect_timer"
                    type="number"
                    min="1"
                    max="60"
                    class="form-control"
                    placeholder="5"
                  >
                  <small class="form-text text-muted">
                    Tempo em segundos antes de redirecionar (1-60 segundos)
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Panel: Preview -->
        <div class="panel panel-right">
          <div class="preview-header">
            <h5>
              <i class="bx bx-show"></i>
              Preview
            </h5>
          </div>
          <div class="preview-scroll">
            <div class="preview-container">
              <div class="preview-content">
                <!-- Ícone com círculo de fundo -->
                <div class="preview-icon-circle" :style="{backgroundColor: pageData.icon_background_color}">
                  <success-icon :color="pageData.icon_color" :size="60" />
                </div>

                <!-- Mensagem Principal -->
                <div
                  class="preview-message"
                  :style="{
                    color: pageData.message_color,
                    fontSize: pageData.message_size
                  }"
                >
                  {{ parseVariables(pageData.message_text) }}
                </div>

                <!-- Código de Confirmação -->
                <div v-if="pageData.show_confirmation_code" class="preview-code">
                  <small class="text-muted">Código de Confirmação</small>
                  <div class="confirmation-code">REG-8472-XQ</div>
                </div>

                <!-- Important Box -->
                <div v-if="pageData.important_box_enabled" class="preview-important-box">
                  <div v-if="pageData.important_box_title" class="important-box-title">
                    {{ pageData.important_box_title }}
                  </div>
                  <div v-if="pageData.important_box_content" class="important-box-content" v-html="formatContent(parseVariables(pageData.important_box_content))"></div>

                  <!-- Botão dentro do Important Box -->
                  <div v-if="pageData.button_enabled && pageData.button_text" class="preview-button-wrapper">
                    <a
                      href="#"
                      class="preview-button"
                      :style="{
                        backgroundColor: pageData.button_color,
                        color: pageData.button_text_color
                      }"
                      @click.prevent
                    >
                      {{ pageData.button_text }}
                    </a>
                  </div>
                </div>

                <!-- Contador de Redirecionamento (Preview) -->
                <div v-if="pageData.redirect_enabled && pageData.redirect_url" class="redirect-countdown-preview">
                  Você será redirecionado em {{ pageData.redirect_timer }} segundo{{ pageData.redirect_timer !== 1 ? 's' : '' }}...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import { mapActions } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import SuccessIcon from './components/SuccessIcon.vue'

export default {
  name: 'ThankYouPageBuilder',
  components: {
    Layout,
    SuccessIcon
  },
  data () {
    return {
      pageId: null,
      saving: false,
      pageData: {
        name: '',
        is_default: false,
        icon_background_color: '#10b981',
        icon_color: '#ffffff',
        message_text: '{Nome}, seu cadastro foi realizado com sucesso!',
        message_color: '#111827',
        message_size: '14px',
        important_box_enabled: true,
        important_box_title: 'IMPORTANTE',
        important_box_content: 'Enviamos um e-mail de confirmação para {Email}. Por favor, verifique sua caixa de entrada.',
        button_enabled: false,
        button_text: 'Continuar',
        button_url: '',
        button_color: '#556ee6',
        button_text_color: '#ffffff',
        show_confirmation_code: false,
        redirect_enabled: false,
        redirect_url: '',
        redirect_timer: 5,
        status: true
      }
    }
  },
  mounted () {
    this.pageId = this.$route.params.id || null
    if (this.pageId) {
      this.loadPage(this.pageId)
    }
    // Adicionar classe ao body
    document.body.classList.add('thank-you-builder-page')
  },
  beforeDestroy () {
    // Remover classe do body ao sair
    document.body.classList.remove('thank-you-builder-page')
  },
  methods: {
    ...mapActions('thankYouPages', {
      createPage: 'CreatePage',
      updatePage: 'UpdatePage'
    }),
    goBack () {
      this.$router.push({ name: 'form-builder-thank-you-pages' })
    },
    async loadPage (id) {
      try {
        const loader = this.$loading.show()
        const response = await services.show(id)
        this.pageData = { ...response.data }
        loader.hide()
      } catch (error) {
        console.error(error)
        errorMessage('Erro ao carregar página')
        this.goBack()
      }
    },
    async save () {
      if (!this.pageData.name) {
        errorMessage('Por favor, preencha o nome da página')
        return
      }

      this.saving = true
      try {
        const loader = this.$loading.show()

        if (this.pageId) {
          await this.updatePage({ id: this.pageId, data: this.pageData })
          successMessage('Página atualizada com sucesso!', 2500)
        } else {
          await this.createPage(this.pageData)
          successMessage('Página criada com sucesso!', 2500)
        }

        loader.hide()
        this.goBack()
      } catch (error) {
        console.error(error)
        errorMessage('Erro ao salvar: ' + (error.response?.data?.message || error.message))
      } finally {
        this.saving = false
      }
    },
    parseVariables (text) {
      if (!text) return ''
      return text
        .replace(/{Nome}/g, 'João Silva')
        .replace(/{Email}/g, 'joao@email.com')
        .replace(/{CodigoConfirmacao}/g, 'REG-8472-XQ')
    },
    formatContent (text) {
      if (!text) return ''
      // Converte quebras de linha em <br>
      return text.replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>
.thank-you-builder {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f6fa;
}

/* Header - Igual ao Form Builder */
.builder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.btn-back {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e9ecef;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s;
}

.btn-back:hover {
  border-color: #556ee6;
  color: #556ee6;
}

.form-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.form-title-input {
  border: none;
  background: transparent;
  font-size: 18px;
  font-weight: 600;
  color: #344054;
  padding: 4px 0;
  width: 300px;
}

.form-title-input:focus {
  outline: none;
  border-bottom: 2px solid #556ee6;
}

.form-status {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background: #e0e7ff;
  color: #4338ca;
}

.form-status.default {
  background: #fef3c7;
  color: #92400e;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-save {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: none;
  background: #556ee6;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-save:hover:not(:disabled) {
  background: #485ec4;
}

.btn-save:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Main Content */
.builder-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-left {
  width: 420px;
  border-right: 1px solid #e9ecef;
  background: #fff;
  flex-shrink: 0;
}

.config-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}

.config-scroll::-webkit-scrollbar {
  width: 6px;
}

.config-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.config-scroll::-webkit-scrollbar-thumb {
  background-color: #d0d5dd;
  border-radius: 3px;
}

.config-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f1f3f5;
}

.config-section:last-child {
  border-bottom: none;
}

.config-section h5 {
  font-size: 14px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 4px;
}

.config-section p.small {
  font-size: 12px;
  margin-bottom: 16px;
}

.panel-right {
  flex: 1;
  background: #f5f6fa;
  display: flex;
  flex-direction: column;
}

.preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;
}

.preview-header h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-header h5 i {
  color: #556ee6;
}

.preview-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 40px 20px;
}

.preview-container {
  max-width: 600px;
  margin: 0 auto;
}

.preview-content {
  background: #ffffff;
  padding: 4rem 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.preview-icon-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
}

.preview-message {
  font-weight: 600;
  margin-bottom: 2rem;
  line-height: 1.4;
}

.preview-code {
  margin: 2rem 0;
  padding: 1.5rem;
  background: #f9fafb;
  border-radius: 8px;
}

.confirmation-code {
  font-size: 20px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 2px;
  margin-top: 0.5rem;
  font-family: 'Courier New', monospace;
}

.preview-important-box {
  margin: 2rem 0;
  padding: 1.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  text-align: left;
}

.important-box-title {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  text-align: center;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}

.important-box-content {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 0;
}

.preview-important-box .preview-button-wrapper {
  margin-top: 1.5rem;
  text-align: center;
}

.preview-button {
  display: inline-block;
  padding: 8px 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.preview-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  text-decoration: none;
}

.redirect-countdown-preview {
  margin-top: 2rem;
  padding: 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  background: #f3f4f6;
  border-radius: 8px;
}

/* Form Controls */
.color-input-group {
  display: flex;
  align-items: center;
}

.form-control-color {
  width: 45px;
  height: 38px;
  padding: 0.25rem;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

label {
  font-size: 13px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 6px;
}

.form-control {
  font-size: 13px;
  border-color: #e9ecef;
  border-radius: 6px;
}

.form-control:focus {
  border-color: #556ee6;
  box-shadow: 0 0 0 3px rgba(85, 110, 230, 0.1);
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #556ee6;
  border-color: #556ee6;
}

.box-settings {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-top: 12px;
}
</style>

<style>
/* Global styles to remove margins/padding when in builder page */
body.thank-you-builder-page {
  overflow: hidden !important;
  height: 100vh !important;
}

body.thank-you-builder-page .main-content {
  padding: 0 !important;
  margin-top: 0 !important;
}

body.thank-you-builder-page .page-content {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: 70px !important;
  height: calc(100vh - 70px) !important;
  display: flex !important;
  flex-direction: column !important;
}

body.thank-you-builder-page .page-content > .container-fluid {
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
  max-width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}
</style>
